import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { percentage, date, currency, zipcode } from '@sparta.sales.helpers/module-utils-helper/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { is } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <section class=\"wrapper-introductory-rate-home-loans\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":115,"column":13}}})) != null ? stack1 : "")
    + "  </section>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"introRate") : depth0),{"name":"with","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":6},"end":{"line":78,"column":15}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"nonIntroRate") : depth0),{"name":"with","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":80,"column":6},"end":{"line":107,"column":15}}})) != null ? stack1 : "")
    + "\r\n      <div class=\"row\">\r\n        <div class=\"small-12 column\">\r\n          <p class=\"assumptions-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"assumptionsLink") || (depth0 != null ? lookupProperty(depth0,"assumptionsLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"assumptionsLink","hash":{},"data":data,"loc":{"start":{"line":111,"column":38},"end":{"line":111,"column":61}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n      </div>\r\n\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"row introductory-rate\">\r\n\r\n          <div class=\"small-12 column\">\r\n\r\n            <div class=\"headline\">\r\n              <h3>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":17,"column":18},"end":{"line":17,"column":34}}}) : helper))) != null ? stack1 : "")
    + "</h3>\r\n            </div>\r\n\r\n              <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"now") : depth0),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":16},"end":{"line":46,"column":25}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"later") : depth0),{"name":"with","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":48,"column":16},"end":{"line":71,"column":25}}})) != null ? stack1 : "")
    + "              </div>\r\n              <p class=\"rate-basis all\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"basis") || (depth0 != null ? lookupProperty(depth0,"basis") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"basis","hash":{},"data":data,"loc":{"start":{"line":73,"column":40},"end":{"line":73,"column":53}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n\r\n          </div>\r\n\r\n        </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"small-12 medium-6 large-4 large-offset-2 column first\">\r\n                     <div "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":23,"column":26},"end":{"line":23,"column":97}}})) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"image") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":24,"column":24},"end":{"line":29,"column":31}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":24},"end":{"line":32,"column":31}}})) != null ? stack1 : "")
    + "                    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subcontent") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":20},"end":{"line":36,"column":27}}})) != null ? stack1 : "")
    + "                    <p class=\"rate\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"rate") || (depth0 != null ? lookupProperty(depth0,"rate") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rate","hash":{},"data":data,"loc":{"start":{"line":37,"column":36},"end":{"line":37,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n                    <p class=\"rate-details\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"details") || (depth0 != null ? lookupProperty(depth0,"details") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"details","hash":{},"data":data,"loc":{"start":{"line":38,"column":44},"end":{"line":38,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rateAlert") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":20},"end":{"line":41,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"basis") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":20},"end":{"line":44,"column":27}}})) != null ? stack1 : "")
    + "                  </div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "class=\"rate-text\" ";
},"7":function(container,depth0,helpers,partials,data) {
    return "class=\"headline-container\"";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <img src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":25,"column":36},"end":{"line":25,"column":45}}}) : helper)))
    + "\" class=\"headline-icon\" aria-hidden=\"true\"/>\r\n                          <h4>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"heading") || (depth0 != null ? lookupProperty(depth0,"heading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"heading","hash":{},"data":data,"loc":{"start":{"line":26,"column":30},"end":{"line":26,"column":45}}}) : helper))) != null ? stack1 : "")
    + "</h4>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <h4>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"heading") || (depth0 != null ? lookupProperty(depth0,"heading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"heading","hash":{},"data":data,"loc":{"start":{"line":28,"column":30},"end":{"line":28,"column":45}}}) : helper))) != null ? stack1 : "")
    + "</h4>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":31,"column":31},"end":{"line":31,"column":43}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <p class=\"subcontent\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"subcontent") || (depth0 != null ? lookupProperty(depth0,"subcontent") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subcontent","hash":{},"data":data,"loc":{"start":{"line":35,"column":42},"end":{"line":35,"column":60}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <p class=\"rate-alert\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"rateAlert") || (depth0 != null ? lookupProperty(depth0,"rateAlert") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rateAlert","hash":{},"data":data,"loc":{"start":{"line":40,"column":46},"end":{"line":40,"column":63}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <p class=\"rate-basis\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"basis") || (depth0 != null ? lookupProperty(depth0,"basis") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"basis","hash":{},"data":data,"loc":{"start":{"line":43,"column":46},"end":{"line":43,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <div class=\"small-12 medium-6 large-4 column end\">\r\n                      <div "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":50,"column":27},"end":{"line":50,"column":63}}})) != null ? stack1 : "")
    + ">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"image") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":51,"column":24},"end":{"line":53,"column":31}}})) != null ? stack1 : "")
    + "                        <h4>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"heading") || (depth0 != null ? lookupProperty(depth0,"heading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"heading","hash":{},"data":data,"loc":{"start":{"line":54,"column":28},"end":{"line":54,"column":43}}}) : helper))) != null ? stack1 : "")
    + "</h4>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":24},"end":{"line":57,"column":31}}})) != null ? stack1 : "")
    + "                    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"subcontent") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":59,"column":20},"end":{"line":61,"column":27}}})) != null ? stack1 : "")
    + "                    <p class=\"rate\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"rate") || (depth0 != null ? lookupProperty(depth0,"rate") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rate","hash":{},"data":data,"loc":{"start":{"line":62,"column":36},"end":{"line":62,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n                    <p class=\"rate-details\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"details") || (depth0 != null ? lookupProperty(depth0,"details") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"details","hash":{},"data":data,"loc":{"start":{"line":63,"column":44},"end":{"line":63,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rateAlert") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":20},"end":{"line":66,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"basis") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":67,"column":20},"end":{"line":69,"column":27}}})) != null ? stack1 : "")
    + "                  </div>\r\n";
},"22":function(container,depth0,helpers,partials,data) {
    return "class=\"rate-text\"";
},"24":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <img src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":52,"column":36},"end":{"line":52,"column":45}}}) : helper)))
    + "\" class=\"headline-icon\" aria-hidden=\"true\"/>\r\n";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data,"loc":{"start":{"line":56,"column":29},"end":{"line":56,"column":41}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"non-introductory-rate\">\r\n\r\n          <div class=\"row\">\r\n            <div class=\"small-12 column\">\r\n              <div class=\"rate-percentage\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"ratePercentage") || (depth0 != null ? lookupProperty(depth0,"ratePercentage") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ratePercentage","hash":{},"data":data,"loc":{"start":{"line":85,"column":43},"end":{"line":85,"column":65}}}) : helper))) != null ? stack1 : "")
    + " </div>\r\n            </div>\r\n            <div class=\"small-12 column\">\r\n              <div class=\"rate-type\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"rateType") || (depth0 != null ? lookupProperty(depth0,"rateType") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rateType","hash":{},"data":data,"loc":{"start":{"line":88,"column":37},"end":{"line":88,"column":53}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n            <div class=\"small-12 column\">\r\n              <p class=\"rate-details\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"rateDetails") || (depth0 != null ? lookupProperty(depth0,"rateDetails") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rateDetails","hash":{},"data":data,"loc":{"start":{"line":94,"column":38},"end":{"line":94,"column":57}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n            </div>\r\n          </div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rateAlert") : depth0),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":98,"column":10},"end":{"line":104,"column":17}}})) != null ? stack1 : "")
    + "          <p class=\"rate-basis\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"basis") || (depth0 != null ? lookupProperty(depth0,"basis") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"basis","hash":{},"data":data,"loc":{"start":{"line":105,"column":32},"end":{"line":105,"column":45}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n";
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"row\">\r\n              <div class=\"small-12 column\">\r\n                <p class=\"rate-alert\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"rateAlert") || (depth0 != null ? lookupProperty(depth0,"rateAlert") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rateAlert","hash":{},"data":data,"loc":{"start":{"line":101,"column":38},"end":{"line":101,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n              </div>\r\n            </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":117,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/introductory-rate-module",
  "version": "2.0.0",
  "id": "introductoryRateModule",
  "containerID": "homeLoansIntroductoryRateModule",
  "moduleName": "home-loans-introductory-rate-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "introductory-rate-module",
  "data": {
    "init": "introductoryRateModule"
  },
  "moduleParams": [{
    "name": "disablePromoOffer",
    "type": "boolean",
    "default": false,
    "description": "If true, a promo offer in the getHelocQuoteDetails response or in the page URL query parameters will be ignored. If false, the normal switching logic is used to determine if a promo offer is present and should be rendered."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        is,
        percentage,
        date,
        currency,
        zipcode
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    is,
    percentage,
    date,
    currency,
    zipcode
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.sales.helpers/module-utils-helper": "^2.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/*
  To test promotional and bau rates in local build, use the "mock" defined in:
    components/modules/home-loans/services-home-loans-module/5.0.1/
    js/endpoints-services-home-loans-module.js

  and used in:
    components/modules/home-loans/services-home-loans-module/5.0.1/
    js/transform-services-home-loans-module.js

  Add the following URL parameters to mock promo or BAU rates:

  /home-equity/?debugging=true&mock=promo
  /home-equity/?debugging=true&mock=bau
*/

/**
 * @class introductoryRateModule
 * @extends Module
 */
class introductoryRateModule extends Module {
  /**
   * @method constructor
   * @param {Object} options module params
   * @param {Object} context module params
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#introductoryRateModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @param {Object} content content
   * @param {Object} data data
   * @return {JSON} initializing helper to pass to model utils
   */
  helperPasser() {
    Handlebars.registerHelper('currency', currency);
    Handlebars.registerHelper('percentage', percentage);
    Handlebars.registerHelper('zipcode', zipcode);
    Handlebars.registerHelper('date', date);
  }

  /**
   * @method render
   * @param {Object} response response object
   * @returns {void}
   */
  render(response) {
    let rates = response.data;
    this.fadeOutRatesFallBack(rates);
    if (rates.payload) {
      rates = rates.payload;
    }
    if (!rates) {
      return;
    }
    const params = Utility.getQueryParamValues(window.location.href);
    const context = {
      params,
      rates
    };
    Utility.render(this.$target, context, Handlebars, introductoryRateModule.rendered);
    // showing module after html renders
    this.$target.removeClass('hide');
    // notify the disclosures toggle module that this module's dagger links need to be re-wired
    this.Events.pub('DISCLOSURES_DAGGER_RE_RENDER', this.$target.find('a.disclosures-dagger'));
    if (params && !_.isEmpty(params.promoOffer)) {
      if (!this.params.disablePromoOffer && params.promoOffer === 'true') {
        this.$target.find('.non-introductory-rate').hide();
        this.$target.find('.introductory-rate').show();
      } else {
        this.$target.find('.introductory-rate').hide();
        this.$target.find('.non-introductory-rate').show();
      }
    } else if (!this.params.disablePromoOffer && rates.product && rates.product.promoOffer) {
      this.$target.find('.non-introductory-rate').hide();
      this.$target.find('.introductory-rate').show();
    } else {
      this.$target.find('.introductory-rate').hide();
      this.$target.find('.non-introductory-rate').show();
    }
    this.updateAssumptionsLink();
  }

  /**
   * @method updateAssumptionsLink
   * @desc add query parameters to assumptions link
   * @returns {void}
   */
  updateAssumptionsLink() {
    let $links = $('.route-home-equity .loan-assumptions-disclosures, .route-home-equity .home-equity-assumptions');
    if (!$links.length) {
      $links = $('.loan-assumptions-disclosures, .home-equity-assumptions');
    }
    const isHomeEquityResearchPage = window.location.href.includes('mortgage/#/home-equity') || window.location.href.includes('mortgage/es/#/home-equity');
    const url = !isHomeEquityResearchPage ? spaParams.pageParams.assumptions : spaParams.siteParams.assumptionsLink['home-equity'];
    let state = this.Store.getData('state');
    if (!state) {
      state = spaParams.pageParams.defaultState;
      this.Store.addData('state', state || '');
    }
    const matches = window.location.pathname.match(/\/(\w{2}\/)$/);
    const language = matches ? matches[1] : '';
    $links.attr('href', `${url}${language}?loanType=homeEquity&state=${state}`);
  }

  /**
   * @method hideRender
   * @param {Object} response response object
   * @returns {void}
   */
  hideRender(response) {
    this.$target.addClass('hide');
    this.fadeInRatesFallBack(response.data);
  }

  /**
   * @method fadeInRatesFallBack
   * @param {Object} response response object
   * @returns {void}
   */
  fadeInRatesFallBack(response) {
    const $cache = $(response.id);
    $cache.fadeIn({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @method fadeOutRatesFallBack
   * @param {Object} response response object
   * @returns {void}
   */
  fadeOutRatesFallBack(response) {
    const $cache = $(response.id);
    $cache.fadeOut({
      duration: 200,
      easing: 'linear'
    });
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    this.helperPasser();
    // initially hiding module so it won't show template to the user
    this.$target.addClass('hide');
    this.Events.sub('HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS', this.render);
    this.Events.sub('HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE', this.hideRender);
    this.Events.sub('HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS', this.render);
    this.Events.sub('HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE', this.hideRender);
    this.Events.pub('HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUBMIT');
  }
}
introductoryRateModule.rendered = {};
registerModuleClass({
  moduleClass: introductoryRateModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { introductoryRateModule as default, moduleConfig };
